import { render, staticRenderFns } from "./PatientFragment.vue?vue&type=template&id=612328cc"
import script from "./PatientFragment.vue?vue&type=script&lang=js"
export * from "./PatientFragment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports